import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBsLfn3D78iP-s2VY7FhV5KiuUi3dMZ4eo",
  authDomain: "oyola-ai.firebaseapp.com",
  projectId: "oyola-ai",
  storageBucket: "oyola-ai.firebasestorage.app",
  messagingSenderId: "560941459989",
  appId: "1:560941459989:web:6ade8e3a98d986dd3b3c1c",
  measurementId: "G-HN0GQQGZYQ",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
